







import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class NoData extends Vue {
  @Prop() icon?: string;
  @Prop() customError?: string;
  @Prop() customHint?: string;

  get errorText(){
    return this.customError ? this.$t(this.customError) : this.$t("NoResults");
  }

  get errorHint(){
    return this.customHint ? this.$t(this.customHint) : this.$t("NoResultsHint");
  }
}
